module.exports = __webpack_public_path__ + "img/Vector.64365ddf.png";